module.exports = __webpack_public_path__ + "static/media/wednesday-in-german.30031bae.png";